export enum AquilaReportIssueTriggerType {
    HOME_PAGE = "HomePage",
    SIDE_PANEL = "SidePanel",
    CREATE_ON_DEMAND_INSIGHT = "CreateOnDemandInsight",
    ALL_INSIGHTS_TAB = "AllInsightsTab",
    ALL_INSIGHTS_SIDEPANEL = "AllInsightsSidePanel",
    ALL_INSIGHTS_CREATE_ON_DEMAND = "AllInsightsCreateOnDemand",
    YOUR_INSIGHT_DECKS_TAB = "YourInsightDecksTab",
    YOUR_INSIGHT_DECKS_SIDEPANEL = "YourInsightDecksSidePanel",
}

export enum AquilaThumbsFeedbackReaction {
    THUMBS_UP = "THUMBS_UP",
    THUMBS_DOWN = "THUMBS_DOWN",
    NONE = "NONE",
}

export enum AquilaThumbsFeedbackPlacement {
    CARD = "CARD",
    SIDE_PANEL = "SIDE_PANEL",
    FOOTER = "FOOTER",
    DECK_DECORATION_WITH_METADATA = "DECK_DECORATION_WITH_METADATA",
}
